import styled from 'styled-components'

export const Wrapper = styled.div`
  padding: 24px;
  border-radius: 16px;
  background: #ffffff;
  border: 1px solid #f0f0f0;
  box-shadow: 0px 4px 8px 0px #00000014;
`
